<!--
    描述：待签署文件
    日期：2022/06/27
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          本次待签署文件{{tableObj.data.length}}份：
        </el-col>
      </el-row>

      <div class="table-content">
        <el-table ref="xTable"
                  :data="tableObj.data"
                  highlight-current-row
                  :height="tableObj.height"
                  size="mini"
                  border>
          <el-table-column type="index"
                           label="序号"
                           align="center"
                           width="65">
          </el-table-column>
          <el-table-column prop="fileId"
                           label="待签署文件ID"
                           align="center"
                           width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="fileName"
                           label="文件名称"
                           align="center"
                           width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop=""
                           label="来源"
                           align="center"
                           width="130"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop=""
                           label="模板编号"
                           width="160"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop=""
                           label="目标文件MIMI类型"
                           width="150"
                           align="center"
                           show-overflow-tooltip>

          </el-table-column>
          <el-table-column prop="fileSize"
                           label="文件大小"
                           min-width="200"
                           header-align="center"
                           sortable
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="convert2Pdf"
                           label="是否转换PDF"
                           width="120"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.convert2Pdf==0">不转换</span>
              <span v-if="scope.row.convert2Pdf==1">转换</span>
            </template>
          </el-table-column>
          <el-table-column prop="companyName"
                           label="是否加密"
                           min-width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName"
                           label="业务码（code)"
                           min-width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName"
                           label="业务信息"
                           min-width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName"
                           label="业务数据"
                           min-width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="uploadUrl"
                           label="文件上传/下载地址"
                           min-width="200"
                           header-align="center"
                           show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from 'api/modules/es/es_file'
export default {
  name : 'detail_tab_tsf',
  components: {

  },
  data() {
    return {
      tableObj : {
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
        data : [],
        height : '440px'
      },
    }
  },
  mounted() {},
  computed: {
    flowId() {
      return this.$route.query.id
    },
  },
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {
    this.getTableList()
  },
  methods: {
    getTableList(){
      let param = {
        flowId : this.flowId
      }
      API.getToBeSignedTableList(param).then(res=>{
        if(res.operationCode == 1) {
          this.tableObj.data = res.data
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.tab-main-page {
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }

    .table-content {

    }
  }
}
</style>